'use client';

import { c as _c } from "react/compiler-runtime";
import { Typography } from '@/shared/ui/atoms';
import { TreatmentCaseListFilter, TreatmentCaseMoreButton } from "@/features/home/ui";
import { TreatmentCaseList } from "@/features/home/ui/organisms";
import useHomeUIStore from "@/features/home/model/ui/store";
import { useQueryTreatmentCaseSummaryList } from '@/entities/treatment-case/hooks/useTreatment';
import { useTranslations } from 'next-intl';
import { TreatmentCaseSummaryResponse } from '@/shared/types/type/treatment';
import { NoDataTemplates } from '@/shared/ui/templates';
interface TreatmentCaseProps {
  initialData: TreatmentCaseSummaryResponse[];
}
const TreatmentCase = t0 => {
  const $ = _c(10);
  const {
    initialData
  } = t0;
  const {
    selectedTreatmentTab
  } = useHomeUIStore();
  const {
    data: treatmentCaseSummaryList
  } = useQueryTreatmentCaseSummaryList(selectedTreatmentTab, initialData);
  const t = useTranslations();
  let t1;
  if ($[0] !== t) {
    t1 = t("treatmentCase.title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Typography size={20} lineHeight={24} className="text-[#2E2F33] font-semibold py-2.5">{t1}</Typography>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TreatmentCaseListFilter />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== treatmentCaseSummaryList) {
    t4 = treatmentCaseSummaryList && treatmentCaseSummaryList.length > 0 ? <><TreatmentCaseList treatmentCaseSummaryList={treatmentCaseSummaryList ?? []} /><TreatmentCaseMoreButton /></> : <NoDataTemplates pageName="treatmentCase" className="mt-10" />;
    $[5] = treatmentCaseSummaryList;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <div className="pt-10 pb-[54px] px-4 bg-white flex-1">{t2}{t3}{t4}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default TreatmentCase;